import { Button, styled } from '@mui/material';

const PREFIX = 'GridActionButton';

export const classes = {
  root: `${PREFIX}-root`,
};

export const StyledButton = styled(Button)({
  [`&.${classes.root}`]: {
    width: '100%',
    fontSize: 10,
    padding: '2px 12px',
  },
});